module.exports = __webpack_public_path__ + "static/floating-action-button-mobile-only-dont-fb9687d480ee3649a7f454f81de930fe.png";